import {
  Box,
  Flex,
  Heading,
  Radio,
  RadioGroup
} from '@sparrowengg/twigs-react';
import { WebhookStateValues, CustomFields } from 'features/apps/add-apps/types';
import {
  authenticationHeader,
  defaultValues
} from 'features/webhook/constants';
import React, { useEffect } from 'react';
import {
  UseFormRegister,
} from 'react-hook-form';
import {
  BasicAuthentication,
  OauthAuthentication,
  CustomHeader,
  TokenAuthentication
} from './headers';
import { AuthenticationHeaderProps } from 'features/webhook/types';

const AuthenticationHeader = ({
  register,
  setValue,
  fields,
  setFields,
  currentHeader,
  handleCurrentHeader,
  trigger,
  errors
}: AuthenticationHeaderProps) => {
  
  useEffect(() => {
    trigger();
  }, [currentHeader]);

  return (
    <Box css={{ marginTop: '$8', flex: 1 }}>
      <Heading css={{ color: '$neutral900' }} size="h6">
        Authentication ( Optional )
      </Heading>
      <Box
        css={{
          paddingInline: "$4",
          paddingBottom: "$8",
          overflowY: 'auto',
          height: "calc(100vh - 366px - 16px)",
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        <RadioGroup
          defaultValue={currentHeader}
          value={currentHeader}
          onChange={(value) => {
            handleCurrentHeader(value);
            Object.keys(defaultValues.properties.headers).forEach((header) =>
              setValue(`properties.headers.${header}`, '', {
                shouldDirty: true
              })
            );
            setValue(
              'authentication',
              (authenticationHeader.find((header) => header.value === value)
                ?.label as string) || 'DEFAULT_HEADER',
              { shouldDirty: true }
            );
          }}
        >
          <Flex
            flexDirection="column"
            css={{ marginTop: '$6', '& > button': { cursor: 'pointer' } }}
          >
            {authenticationHeader.map((header) => (
              <Box
                key={header.id}
                css={{
                  '& label': {
                    color: '$neutral900 !important',
                    cursor: 'pointer'
                  }
                }}
              >
                <Box
                  css={{
                    label: {
                      lineHeight: '$md',
                      paddingBlock: '$4'
                    }
                  }}
                >
                  <Radio value={header.value} css={{}}>
                    {header.name}
                  </Radio>
                </Box>
                {header.value === currentHeader ? (
                  <CurrentHeader
                    register={register}
                    fields={fields}
                    setFields={setFields}
                    currentHeader={currentHeader}
                    errors={errors}
                  />
                ) : null}
              </Box>
            ))}
          </Flex>
        </RadioGroup>
      </Box>
    </Box>
  );
};

const CurrentHeader = ({
  currentHeader,
  register,
  fields,
  setFields,
  errors
}: {
  currentHeader: string;
  register: UseFormRegister<WebhookStateValues>;
  fields: CustomFields[];
  setFields: React.Dispatch<React.SetStateAction<CustomFields[]>>;
  errors: any;
}) => {
  switch (currentHeader) {
    case 'basicAuthentication':
      return <BasicAuthentication register={register} errors={errors} />;
    case 'tokenAuthentication':
      return <TokenAuthentication register={register} errors={errors} />;
    case 'customHeader':
      return <CustomHeader fields={fields} setFields={setFields} />;
    case 'oauthAuthentication':
      return <OauthAuthentication register={register} errors={errors} />;
    default:
      return null;
  }
};

export default AuthenticationHeader;
